export default function CsharpAddTwoNumbers() {
  return (
    <h2>Csharp Add Two Numbers</h2>
  );
}
